<template>
    <div class="LegendTag">
        <span
            class="LegendTag__dot"
            :style="dotStyle"
        ></span>
        <span class="LegendTag__text">{{ label }}: {{ percent }}%</span>
    </div>
</template>
<script>
export default {
    name: 'LegendTag',
    props: {
        label: {
            type: String,
            required: true
        },
        percent: {
            type: Number,
            required: true
        },
        color: {
            type: String,
            required: true
        },
    },
    computed: {
        dotStyle(){
            return {
                background: this.color
            };
        }
    }
};
</script>
<style lang="scss">
    .LegendTag {
        display: flex;
        align-items: center;
        &__dot {
            height: .5rem;
            width: .5rem;
            border-radius: 50%;
            margin-right: 0.25rem;
        }
        &__text {
            color: $text-grey;
        }
    }
</style>
